import {envbase} from "../env.const";

/**
 * Môi trường phục vụ NHÚNG VÀO CRM khi đang phát triển (Development)
 * - Dùng cho build FE standalone, test giao diện nhanh ko cần backend
 * - Được kích hoạt thông qua lệnh: npm run build:fe:web:dev
 * */
export const environment = {
  ...envbase,
  isMobileLayout: true,
  baseUrlApi: 'https://dunghvbe.vpage.nhanhdev.com',

  api_zalo_personal_url: 'http://localhost:3000',
  socket_io: {
    url: 'https://socketvpagedev.bot3s.com:8443/nsp-crm',
    secretKey: 'v28931njAIZzxciiuadnXCoi213joi12zxc129zWWAzoi1ZIA'
  },
  serverSSR: {
    ...envbase.serverSSR,
    USE_RENDERING: false
  },
  facebook: {
    login_business: {
      config_marketing_messages: '1123978399590499',
      config_marketing_messages_non_business: '25327725986887032',
    }
  },

  auth: {
    login_url: '/auth/login',
    login_app_url: '/auth/login-appmobile',
    logout_url: '/auth/login',
    logout_app_url: '/auth/login?isMobileApp=1',
    change_account_url: '/auth/login?isChangeAccount=1',
    request_perms: '/auth/requestperms',
    request_fb_insta_perms: '/auth/requestfbperms',
    request_zalo_perms: '/auth/requestzaloperms',
    request_shopee_perms: '/auth/requestshopeeperms',
    request_google_perms: '/auth/requestgoogleperms',
    request_lazada_perms: '/auth/requestlazadaperms',
  },
  nhanh_vn: {
    sale_channel: {
      FB: 20,
      INSTA: 21,
      ZALO_OA: 49,
      SHOPEE_CHAT: 50,
      LAZADA_CHAT: 51,
      ZALO_PERSONAL: 52,
      TIKTOK_CHAT: 60
    },
    admin: 'https://cuongnvpos.bot3s.com/admin',
    product_list_url: 'https://cuongnvpos.bot3s.com/product/item/crmindex',
    order_add_url: 'https://cuongnvpos.bot3s.com/order/manage/crmadd',
    order_add_url_v2: 'https://cuongnvpos.bot3s.com/order/manage/crmadd2',
    order_list_url: 'https://cuongnvpos.bot3s.com/order/manage/crmindex',
    top_order: 'https://cuongnvpos.bot3s.com/order/manage/crmlastestorders'
  }
};
